import { HistoryCache } from "@web/route-services/chat/history-cache";
import { ChatService, useChatService } from "@web/route-services/chat/use-chat-service";
import { createContext, MutableRefObject, useContext } from "react";

interface Flag {
  sent: boolean;
  replied: boolean;
  fetchedPreviousPage: boolean;
  newChunk: boolean;
}

interface Context {
  isGenerating: boolean;
  editingMessageID?: number;
  bottomCandidateIDX?: number;
  editText?: string;
  flagRef: MutableRefObject<Flag>;
  historyRef: MutableRefObject<Element | null>;
  service: ChatService;
}

const Context = createContext<Context>({} as any);

export const useServiceContext = () => {
  return useContext(Context);
};

export const ServiceContextProvider = ({
  chatID,
  historyRef,
  children
}: {
  chatID: number;
  historyRef: MutableRefObject<Element | null>;
  children: React.ReactNode;
}) => {
  const cache = new HistoryCache({ chatID });
  const { isGenerating, bottomCandidateIDX, editingMessageID, chatService, flagRef } = useChatService({
    chatID,
    cache,
    historyRef
  });

  const context: Context = {
    isGenerating,
    editingMessageID,
    bottomCandidateIDX,
    service: chatService,
    historyRef,
    flagRef
  };

  return <Context.Provider value={context}>{children}</Context.Provider>;
};
